import { render } from "./ReportBuilderList.vue?vue&type=template&id=3a49779a"
import script from "./ReportBuilderList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportBuilderList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Insights/ReportBuilderList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a49779a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a49779a', __exports__)) {
    api.reload('3a49779a', __exports__)
  }
  
  module.hot.accept("./ReportBuilderList.vue?vue&type=template&id=3a49779a", () => {
    api.rerender('3a49779a', render)
  })

}


export default __exports__